const reportGadgetHasCustomFilters = (
  gadget: ReportGadgets.ReportGadget,
): boolean => {
  return !!(
    gadget.scope?.length ||
    gadget.dateField ||
    gadget.comparison ||
    gadget.isDefaultFiltersDisabled
  );
};

export default reportGadgetHasCustomFilters;
